import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next"

// Etichette abbreviazione lingua (maiuscolo). 'en'/'gb' → 'EN' (formula più comune).
const LANG_LABELS = { it: 'IT', en: 'EN', gb: 'EN', fr: 'FR', de: 'DE' };

const LanguageSelector = () => {
    const { i18n } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng)
    };

    // Questo passaggio risolve il problema che Safari e firefox a lingua non storata mostrano un etichetta it-IT invece che it
    const [formattedInitLanguage, setFormattedInitLanguage] = useState('');
    useEffect(() => {
        const lang = i18n.language;
        const shortLang = lang.includes('-') ? lang.split('-')[0] : lang;
        setFormattedInitLanguage(shortLang);
    }, [i18n.language]);

    return (
        // Niente margini verticali: il componente si allinea ai fratelli tramite l'`items-center`
        // del contenitore. Un `mt-2` qui lo faceva sedere più in basso di Accedi / + / lente
        // in ogni pagina che lo ospita.
        <div className="cursor-pointer flex flex-col items-center z-30 relative" onClick={() => setIsOpen(prevState => (!prevState))}>
            <div className="flex gap-1 items-center leading-none">
                <div className="leading-none text-neutral-500">{LANG_LABELS[formattedInitLanguage] || (formattedInitLanguage || i18n.language).toUpperCase()}</div>
                <i className="fi fi-rr-globe text-gray-800 text-2xl leading-none flex items-center"></i>
            </div>
            {
                isOpen &&
                <div className="absolute top-10 right-0 md:right-auto border rounded-xl flex flex-row md:flex-col gap-4 md:gap-2 py-2 px-4 bg-white">
                    <div className="text-3xl" onClick={() => changeLanguage('it')}>🇮🇹</div>
                    <div className="text-3xl" onClick={() => changeLanguage('en')}>🇬🇧</div>
                    <div className="text-3xl" onClick={() => changeLanguage('fr')}>🇫🇷</div>
                    <div className="text-3xl" onClick={() => changeLanguage('de')}>🇩🇪</div>
                </div>
            }

        </div>
    )
}

export default LanguageSelector